import { call, put, takeEvery } from "redux-saga/effects";
import {
  FETCH_TRANSACTIONS_HISTORY_REQUEST,
  FETCH_TRANSACTIONS_HISTORY_SUCCESS,
  FETCH_TRANSACTIONS_HISTORY_FAILURE,
} from "./actionTypes";
import { fetchTransactionsHistorySuccess, fetchTransactionsHistoryFailure } from "./actions";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../../helpers/firebase/firebaseConfig";

function* fetchTransactionsHistorySaga() {
  try {
    const querySnapshot = yield call(getDocs, collection(db, "providers_transactions_history"));
    const transactions = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    yield put(fetchTransactionsHistorySuccess(transactions));
  } catch (error) {
    yield put(fetchTransactionsHistoryFailure(error.message));
  }
}

function* transactionHistorySaga() {
  yield takeEvery(FETCH_TRANSACTIONS_HISTORY_REQUEST, fetchTransactionsHistorySaga);
}


export default transactionHistorySaga;